import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Route, RouterModule } from '@angular/router';
import { SettingsComponent } from '../../components/settings/settings.component';
import { CvvCommonModule } from '../cvv-common/cvv-common.module';

const routes: Route[] = [{
  path: 'settings',
  component: SettingsComponent,
  children: [
    {path: 'create', component: SettingsComponent, outlet: 'side'}
  ]
}];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    MatSlideToggleModule,
    MatCardModule,
    CvvCommonModule,
    MatButtonModule,
    MatRadioModule,
    MatIconModule,
    MatExpansionModule
  ],
  declarations: [SettingsComponent],
  exports:[SettingsComponent]
})
export class SettingsModule { }
